var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYesorno = function SvgYesorno(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".yesorno_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.91 23.5-4.016-6.015c-.454-.7-.455-2.009.545-2.009s2.061.411 4.061 3.493V7.982A1.49 1.49 0 0 1 10.992 6.5 1.507 1.507 0 0 1 12.5 8v5.97l4.447 1.5c.988.317 1.207 1.5.974 2.516L16.894 23.5M7.5.499l-5 7-2-2M16.5.499l7 7M23.5.499l-7 7",
    className: "yesorno_svg__a"
  })));
};
export default SvgYesorno;